"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _Header = _interopRequireDefault(require("../../../components/Modals/Header.styled"));
var _reactstrap = require("reactstrap");
var _components = require("../../../components");
var _ModalTypes = require("../../../constants/ModalTypes");
function LoadBroadcastError() {
  var isOpen = (0, _reactRedux.useSelector)(function (_ref) {
    var modal = _ref.modal;
    return modal && modal.type === _ModalTypes.LOAD_BROADCAST_ERROR;
  });
  var description = 'There was a problem loading this broadcast. Please try a browser refresh and if the problem persists, reach out to client support.';
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
    isOpen: isOpen
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null, "Uh oh"), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, null, /*#__PURE__*/_react["default"].createElement(_components.ErrorBoundary, {
    description: description
  })));
}
var _default = exports["default"] = LoadBroadcastError;